import { z } from 'zod';

import { ZodTaigaIdUriEncoded } from '@Common/types/b2b/axa/common';
import { ZodId } from '@Common/types/request';
import { createZodParamsValidator } from '@Common/types/zod/zod-params';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

// Kept apart from transaction_by_id so that profile/transactions can import it without a cycle
export const ZodGetTransactionPathParams = createZodParamsValidator(
  z.object({
    id: z.union([ZodId, ZodTaigaIdUriEncoded, ZodTrimmedString]),
  }),
);
export type GetTransactionPathParams = z.infer<typeof ZodGetTransactionPathParams>;
